import { BaseStorage } from '../base-storage';
import { NOT_FOUND } from '../utils/constants';
import { LocalStorageStrategy, } from './local-storage';
import { NullStrategy } from './null-storage';
import { getUserId, WixStorageStrategy } from './wix-storage';
const DELETED = '___DELETED___';
export class CachedStorageStrategy extends BaseStorage {
    constructor({ remoteStrategy, localStrategy, }) {
        super();
        if (shouldIgnoreCache(remoteStrategy)) {
            localStrategy = new NullStrategy();
        }
        this.remoteStrategy = BaseStorage.verify(remoteStrategy);
        this.localStrategy = BaseStorage.verify(localStrategy || new LocalStorageStrategy());
    }
    extendScope(scope) {
        return this.remoteStrategy.extendScope(scope);
    }
    _cacheItem(key, value, options) {
        return this.localStrategy.setItem(key, value, Object.assign(options, { expiration: 3600 }));
    }
    setItem(key, value, options) {
        return this.remoteStrategy
            .setItem(key, value, options)
            .then(() => this._cacheItem(key, value, options));
    }
    removeItem(key, options) {
        return this.remoteStrategy
            .removeItem(key, options)
            .then(() => this._cacheItem(key, DELETED, options));
    }
    getItem(key, options) {
        function throwIfDeletedOrReturn(value) {
            if (value === DELETED) {
                throw NOT_FOUND;
            }
            return value;
        }
        return this.localStrategy
            .getItem(key, options)
            .catch(() => this._getRemoteAndCache(key, options))
            .then(throwIfDeletedOrReturn);
    }
    getAllItems(options) {
        return this.remoteStrategy
            .getAllItems(options)
            .then((items) => Promise.all(Object.keys(items).map((key) => this._cacheItem(key, items[key], options))).then(() => items));
    }
    _getRemoteAndCache(key, options) {
        return this.remoteStrategy
            .getItem(key, options)
            .then((value) => {
            return this._cacheItem(key, value, options).then(() => value);
        })
            .catch((e) => {
            if (e === NOT_FOUND) {
                return this._cacheItem(key, DELETED, options).then(() => {
                    throw e;
                });
            }
            throw e;
        });
    }
}
// we don't support local strategy in case we cannot
// identify the user - mainly on viewer flow.
function shouldIgnoreCache(remoteStrategy) {
    return (remoteStrategy &&
        remoteStrategy.constructor === WixStorageStrategy &&
        getUserId() === '');
}
//# sourceMappingURL=cached-storage.js.map